import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "tab-bar-container" }
const _hoisted_2 = { class: "tab-bar-box" }
const _hoisted_3 = { class: "tab-bar-scroll" }
const _hoisted_4 = { class: "tags-wrap" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "tag-link" }
const _hoisted_7 = ["onClick"]

import { ref, computed, watch } from "vue";
  import { useRouter } from "vue-router";
  import type { RouteLocationNormalized } from "vue-router";
  import { listenerRouteChange } from "@/utils/route-listener";
  import { useAppStore, useTabBarStore } from "@/store";
  import type { TagProps } from "@/store/modules/tab-bar/types";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

  const appStore = useAppStore();
  const tabBarStore = useTabBarStore();

  const router = useRouter();
  const affixRef = ref();
  const tagList = computed(() => {
    return tabBarStore.getTabList;
  });
  const offsetTop = computed(() => {
    return appStore.navbar ? 60 : 0;
  });

  watch(
    () => appStore.navbar,
    () => {
      affixRef.value.updatePosition();
    }
  );
  listenerRouteChange((route: RouteLocationNormalized) => {
    if (!route.meta.noAffix && !tagList.value.some((tag) => tag.fullPath === route.fullPath)) {
      tabBarStore.updateTabList(route);
    }
  }, true);
  const tagClose = (tag: TagProps, idx: number) => {
    tabBarStore.deleteTag(idx, tag);
    if (idx === tagList.value.length) {
      const latest = tagList.value[tagList.value.length - 1];
      router.push({ name: latest.name });
    }
  };
  const goto = (tag: TagProps) => {
    router.push({ ...tag });
  };

return (_ctx: any,_cache: any) => {
  const _component_icon_close = _resolveComponent("icon-close")!
  const _component_a_affix = _resolveComponent("a-affix")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_affix, {
      ref_key: "affixRef",
      ref: affixRef,
      "offset-top": offsetTop.value
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tagList.value, (tag, index) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: tag.fullPath,
                  class: _normalizeClass(["arco-tag arco-tag-size-medium arco-tag-checked", { 'link-actived': tag.fullPath === _ctx.$route.fullPath }]),
                  onClick: ($event: any) => (goto(tag))
                }, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t(tag.title)), 1),
                  _createElementVNode("span", {
                    class: "arco-icon-hover arco-tag-icon-hover arco-icon-hover-size-medium arco-tag-close-btn",
                    onClick: _withModifiers(($event: any) => (tagClose(tag, index)), ["stop"])
                  }, [
                    _createVNode(_component_icon_close)
                  ], 8, _hoisted_7)
                ], 10, _hoisted_5))
              }), 128))
            ])
          ]),
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "tag-bar-operation" }, null, -1))
        ])
      ]),
      _: 1
    }, 8, ["offset-top"])
  ]))
}
}

})